<template>
      <section class="card card--heart" value="2">
      <div class="card__inner card__inner--centered">
        <div class="card__column">
          <div class="card__symbol"></div>
          <div class="card__symbol"></div>
        </div>
      </div>
      </section>
</template>

<script>
export default {
  name: 'Card',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>

  $color: #c0c0c0;
  $background: #f0f0f0;
  $gutter: 0px;
  $font-size: 14px;

  $card-background: #fff;
  $card-padding: 5px;
  $card-width: 100px;
  $card-height: 140px;
  $card-color-red-1: #e44145;
  $card-color-red-2: #FF94A6;

  $card-color-black: #252525;
  $card-symbol-size: 20px;

.card {
	position: relative;
	display: inline-block;
	width: $card-width;
	height: $card-height;
	font: $font-size 'Noto Sans TC';
	
	margin: $gutter;
	border-radius: $card-padding;
	background: $card-background;
  
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
	
	&:before,
	&:after {
		content: attr(value);
		position: absolute;
		width: 12px;
		text-align: center;
		letter-spacing: -2px;
	}
	
	&:before {
		top: $card-padding;
		left: $card-padding;
	}
	
	&:after {
		bottom: $card-padding;
		right: $card-padding;
		transform: rotate(180deg)
	}
	
	&--heart {
		color: $card-color-red-1;
    // background: -webkit-gradient(linear,top,,$card-color-red-1, $card-color-red-2);
    // background: linear-gradient(to bottom,$card-color-red-1, $card-color-red-2);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // -webkit-box-decoration-break: clone;
    // box-decoration-break: clone;
    // text-shadow: none;

    // background-color: linear-gradient($card-color-red-1, $card-color-red-2);
    // background: linear-gradient($card-color-red-1, $card-color-red-2);
    // -webkit-background-clip: text;
    // color: transparent;
		&:before,
		&:after {
			content: attr(value) ' ♥';
		}
	}
	
	&--spade {
		color: var(--card-color-black);
		
		&:before,
		&:after {
			content: attr(value) ' ♠';
		}
	}

	&--clubs {
		color: var(--card-color-black);		
		&:before,
		&:after {
			content: attr(value) ' ♣';
		}
	}

	
	&--diamonds {
		color: $card-color-black;
		
		&:before,
		&:after {
			content: attr(value) ' ♦';
		}
	}
}

.card__inner {
	box-sizing: border-box;
	position: absolute;
	display: flex;
	justify-content: space-between;
	top: 10px;
	left: 6px;
	right: 6px;
	bottom: 10px;
	
	&--centered {
		justify-content: center;
	}
}

.card__column {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	
	&--centered {
		justify-content: center;
	}
}

.card__symbol {
	display: inline-block;
	height: $card-symbol-size;
	text-align: center;
	
	&:before {
		font-size: $card-symbol-size;
		line-height: $card-symbol-size;
	}
	
	.card--heart &:before {
		content: '♥';
	}
	
	.card--spade &:before {
		content: '♠';
	}

	.card--clubs &:before {
		content: '♣';
	}
	
	.card--diamonds &:before {
		content: '♦';
	}
	
	&--rotated,
	&:last-of-type {
		transform: rotate(180deg);
	}
	
	&:first-of-type {
		transform: rotate(0);
	}
	
	&--big {
		flex-basis: 35px;
	}
	
	&--huge {
		flex-basis: 63px;
	}
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
